import React from "react";

import StarsIcon from "@uui/Stars02";

import {
  Popover,
  PopoverProps,
  Stack,
  Typography,
  styled,
} from "@mui/material";

import { Row } from "@rui/Stack";
import { Bold } from "@rui/styles";

import { SEARCH_TIPS } from "./constants";
import { SearchTip } from "./styles";

const SearchPopoverContainer = styled(Stack)(({ theme }) => ({
  width: `100%`,
  padding: theme.spacing(2, 1.25),
}));

const SearchPopover = (props: PopoverProps) => {
  return (
    <Popover
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      disableAutoFocus
      disableEnforceFocus
      {...props}
      sx={{ pointerEvents: "none" }}
    >
      <SearchPopoverContainer spacing={1.5} sx={{ ...props.sx }}>
        <Row
          sx={{ color: "shades.neutral.600", paddingY: 0.5 }}
          variant="left"
          spacing={0.25}
        >
          <StarsIcon sx={{ color: "shades.primary.500", height: "18px" }} />
          <Typography
            variant="bodySecondaryReg"
            sx={{ color: "shades.neutral.700" }}
          >
            <Bold>Search tip:</Bold> use the following search commands for more
            focused results
          </Typography>
        </Row>
        <Stack spacing={0.5}>
          {SEARCH_TIPS.map((tip, i) => (
            <SearchTip key={i} {...tip} />
          ))}
        </Stack>
      </SearchPopoverContainer>
    </Popover>
  );
};

export default SearchPopover;
